@if ((viewModel$ | async); as vm) {
  @if (vm.hasChapters) {
    <cm-chapter-themas [isReadonly]="vm.isReadonly"></cm-chapter-themas>
  } @else {
    <cm-project-level-themas [isReadonly]="vm.isReadonly"></cm-project-level-themas>
  }
}